import React from 'react';

const Modal = ({
  isOpen,
  onClose,
  children,
  zIndex = 50,
  showCloseButton = true,
  closeOnBackdropClick = true,
  maxWidth = 'lg',
}) => {
  if (!isOpen) {
    return null;
  }

  // Convert zIndex to proper Tailwind z-index classes
  const getZIndexClass = (zIndex) => {
    switch (zIndex) {
      case 40: return 'z-40';
      case 50: return 'z-50';
      case 60: return 'z-60';
      case 70: return 'z-70';
      case 80: return 'z-80';
      case 90: return 'z-90';
      case 100: return 'z-[100]';
      default: return 'z-50';
    }
  };

  // Convert maxWidth to proper Tailwind max-width classes
  const getMaxWidthClass = (maxWidth) => {
    switch (maxWidth) {
      case 'sm': return 'max-w-sm';
      case 'md': return 'max-w-md';
      case 'lg': return 'max-w-lg';
      case 'xl': return 'max-w-xl';
      case '2xl': return 'max-w-2xl';
      case '3xl': return 'max-w-3xl';
      case '4xl': return 'max-w-4xl';
      case '5xl': return 'max-w-5xl';
      case '6xl': return 'max-w-6xl';
      default: return 'max-w-lg';
    }
  };

  return (
    <div 
      className={`fixed inset-0 ${getZIndexClass(zIndex)} flex items-center justify-center bg-black bg-opacity-50`}
      onClick={closeOnBackdropClick ? onClose : undefined}
    >
      <div 
        className={`relative w-full ${getMaxWidthClass(maxWidth)} p-8 mx-4 bg-white rounded-lg shadow-xl dark:bg-gray-800`}
        onClick={(e) => e.stopPropagation()}
      >
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal; 